import React, { useState } from 'react';
// import DraggableList from '../components/DraggableList';
// import DraggableList2 from '../components/DraggableList2';
import DraggableList from '../components/DraggableList';
import WinnerScreen from '../components/WinnerItem';
import styles from './SurveyScreenStyle'; // Import the styles object
import SpinnerComponent from '../components/Spinner';

const SurveyScreen = ({ project }) => {

  const { tools_items } = project;

  const [winnerItems, setWinnerItems] = useState([]);
  const [items, setItems] = useState(null);

  const [showComponent1, setShowComponent1] = useState(true);
  const [showComponent2, setShowComponent2] = useState(false);

  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    setShowComponent1(false);
    setShowComponent2(true);
  };

  const handleGoBack = () => {
    setShowComponent1(true);
    setShowComponent2(false);
  };

  return (
    <div style={styles.app(project)}>
      {showComponent1 && !loading ? (
        <div style={{ ...styles.component1(), ...(showComponent1 ? styles.component1Active() : {}) }}>
          <DraggableList
            project={project}
            setWinnerItems={setWinnerItems}
            toggleComponent={handleSubmit}
            items={items || tools_items}
            setItems={setItems}
            setLoading={setLoading}
          />
          {/* <DraggableList2 items={items2} setItems={setItems2} /> */}
        </div>
      ) : (
        <div style={{
          ...styles.component2(),
          ...(showComponent2 ? styles.component2Active() : {}),
          display: loading ? 'none' : 'contents '
        }}>
          <WinnerScreen
            winnerItems={winnerItems}
            toggleComponent={handleGoBack}
            project={project}
            loading={loading}
          />
        </div>
      )}
      <SpinnerComponent loading={loading} />
    </div>
  );
};

export default SurveyScreen;
